// Délégation d'événements : Dawn ré-écrit le HTML du sélecteur de variante à
// chaque changement (mise à jour prix/disponibilité), ce qui remplace les
// éléments et détruirait des écouteurs attachés directement sur les boutons.
// En écoutant depuis document, on retrouve toujours les éléments à jour au
// moment du clic, quel que soit le nombre de ré-rendus.
document.addEventListener('click', (event) => {
  const button = event.target.closest('.tdp-longlist__option');
  if (!button) {
    const openDetails = document.querySelectorAll('.tdp-longlist__details[open]');
    openDetails.forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
    return;
  }

  const wrapper = button.closest('[data-tdp-longlist]');
  if (!wrapper) return;
  const details = wrapper.querySelector('.tdp-longlist__details');
  const select = wrapper.querySelector('[data-tdp-longlist-select]');
  const label = wrapper.querySelector('[data-tdp-longlist-label]');
  if (!details || !select || !label) return;

  const value = button.dataset.value;

  wrapper.querySelectorAll('.tdp-longlist__option').forEach((el) => {
    el.classList.toggle('is-selected', el === button);
    el.setAttribute('aria-selected', el === button ? 'true' : 'false');
  });
  label.textContent = value;
  details.open = false;

  if (select.value !== value) {
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
});
